import { FC } from 'react';

import { Box } from '@mui/material';

import { IModalProps as Props } from 'interfaces/auth';

import { ModalComponent } from 'components/_basic/ModalComponent/ModalComponent';
import { Stepper } from 'components/_basic/Stepper/Stepper';

import {
  ChangeEmailContextProvider,
  useChangeEmailContext,
} from './ChangeEmailContextProvider/ChangeEmailContextProvider';
import { EnterConfirmationCodeStep, EnterNewEmailStep } from './ChangeEmailForms';

import styles from './ChangeEmail.module.scss';

export const ChangeEmail: FC<Props> = ({ isModalOpened, onModalClose }) => {
  const stepArray = [EnterNewEmailStep, EnterConfirmationCodeStep];

  return (
    <ChangeEmailContextProvider isModalOpened={isModalOpened}>
      <ModalComponent open={isModalOpened} onClose={onModalClose}>
        <Box className={styles.changeEmailModaLWrapper}>
          <Stepper useModalContext={useChangeEmailContext} stepForms={stepArray} onClose={onModalClose} />
        </Box>
      </ModalComponent>
    </ChangeEmailContextProvider>
  );
};
